/**
 * Unpaid post-booking bags live only in the checkout cart. Leaving checkout
 * (header or browser back) should drop them so the picker reopens from the booking.
 * Payment in progress keeps the cart so a redirect can still finalise.
 */
export function shouldDiscardFlightBaggageOnCheckoutExit(
  checkout: { cart?: { mode?: App.CheckoutCartMode }, processing?: boolean },
): boolean {
  return checkout.cart?.mode === 'flight-baggage' && !checkout.processing
}
